import instance from "../../axios/axios-user";
import { ArticleProps } from "../../redux/slices/article/Article";
import { API_PATHS } from "../api_paths";

const createOrUpdateArticleContent = ({
  content_data,
  content_id,
  content_type,
  element_role,
  image,
  post_id,
  article_order,
}: ArticleProps.createOrUpdateArticleContentPayload) => {
  const formdata = new FormData();
  formdata.append("post_id", post_id);
  formdata.append("content_type", String(content_type));
  formdata.append("element_role", element_role);
  formdata.append("article_order", String(article_order));
  content_id && formdata.append("content_id", content_id);
  content_data && formdata.append("content_data", content_data);
  if (image) {
    if (Array.isArray(image)) {
      image.forEach((file) => {
        formdata.append("images", file);
      });
    } else formdata.append("images", image);
  }
  return instance(API_PATHS.article.articleContent, {
    method: "POST",
    data: formdata,
  });
};

const deleteASingleArticleContent = (post_article_id: number) =>
  instance(API_PATHS.article.articleContent + `/${post_article_id}`, {
    method: "DELETE",
  });

const createArticleDraft = () =>
  instance(API_PATHS.article.articleDraft, { method: "POST" });

const deleteArticleDraft = (post_id: string) =>
  instance(API_PATHS.article.articleDraft + `/${post_id}`, {
    method: "DELETE",
  });

const reorderArticleEntries = ({
  post_id,
  data,
}: ArticleProps.reorderArticleEntriesPayload) => {
  return instance(API_PATHS.article.articleDraft + `/${post_id}/reorder`, {
    method: "PUT",
    data,
  });
};

const listArticleDrafts = () => instance(API_PATHS.article.articleDrafts);

const listPublishedArticles = () =>
  instance(API_PATHS.article.articlePublished);

const listScheduledArticles = () =>
  instance(API_PATHS.article.articleScheduled);

const getASingleArticleDraft = (post_id: string) =>
  instance(API_PATHS.article.articleDrafts + `/${post_id}`);

const publishArticleDraft = (post_id: string, scheduled_data?: string) => {
  return instance(API_PATHS.article.articleDraft + `/${post_id}/publish`, {
    method: "PUT",
    data: { scheduled_data },
  });
};

const rescheduleAScheduledArticleDraft = (
  post_id: string,
  scheduled_data: string
) => {
  return instance(API_PATHS.article.articleManage + `/${post_id}/reschedule`, {
    method: "PUT",
    data: { scheduled_data },
  });
};

const duplicateAnArticleDraftAsANewDraft = (post_id: string) => {
  return instance(API_PATHS.article.articleManage + `/${post_id}/duplicate`, {
    method: "POST",
  });
};

const uploadAudioForArticleDraft = ({
  post_id,
  audio,
  content_id,
}: ArticleProps.uploadAudioForArticleDraftPayload) => {
  const formData = new FormData();
  formData.append("post_id", post_id);
  formData.append("content_id", content_id);
  formData.append("audio", audio);
  return instance(API_PATHS.article.articleDraft + `/${post_id}/audio-upload`, {
    method: "POST",
    data: formData,
  });
};

const deleteArticleAudio = (data: ArticleProps.deleteArticleAudioPayload) => {
  return instance(API_PATHS.article.articlesAudio, {
    method: "DELETE",
    data,
  });
};

const uploadAudioBackground = ({
  post_id,
  image,
  content_id,
  gradient,
}: ArticleProps.uploadAudioBackgroundPayload) => {
  const formData = new FormData();
  formData.append("content_id", content_id);
  gradient && formData.append("gradient", gradient);
  image && formData.append("image", image);
  return instance(API_PATHS.article.articleDraft + `/${post_id}/audio-image`, {
    method: "POST",
    data: formData,
  });
};

const deleteArticleAudioImage = ({
  post_id,
  content_id,
}: ArticleProps.deleteArticleAudioImagePayload) => {
  return instance(API_PATHS.article.articleDraft + `/${post_id}/audio-image`, {
    method: "DELETE",
    data: { post_id, content_id },
  });
};

const uploadVideoForArticleDraft = ({
  post_id,
  video,
  content_id,
}: ArticleProps.uploadVideoForArticleDraftPayload) => {
  const formData = new FormData();
  formData.append("post_id", post_id);
  formData.append("content_id", content_id);
  formData.append("video", video);
  return instance(API_PATHS.article.articleDraft + `/${post_id}/video-upload`, {
    method: "POST",
    data: formData,
  });
};

const deleteVideoFromAArticle = (
  data: ArticleProps.deleteVideoFromAArticlePayload
) => {
  return instance(API_PATHS.article.articlesVideo, {
    method: "DELETE",
    data,
  });
};

const deleteAnArticleImage = (id: string) => {
  return instance(API_PATHS.article.articleImages + id, {
    method: "DELETE",
  });
};

const reorderImagesInAnImageBlock = (
  post_article_id: number,
  image_ids: string[]
) => {
  return instance(
    API_PATHS.article.articleImages + post_article_id + "/reorder",
    {
      method: "PUT",
      data: { image_ids },
    }
  );
};

export const ARTICLE = {
  //common
  createOrUpdateArticleContent,
  deleteASingleArticleContent,
  createArticleDraft,
  deleteArticleDraft,
  reorderArticleEntries,
  listArticleDrafts,
  getASingleArticleDraft,
  listPublishedArticles,
  listScheduledArticles,
  publishArticleDraft,
  duplicateAnArticleDraftAsANewDraft,
  rescheduleAScheduledArticleDraft,

  //audio
  uploadAudioForArticleDraft,
  deleteArticleAudio,
  uploadAudioBackground,
  deleteArticleAudioImage,

  //video
  uploadVideoForArticleDraft,
  deleteVideoFromAArticle,

  //image
  deleteAnArticleImage,
  reorderImagesInAnImageBlock,
};
